// JS to do.
import sal from 'sal.js';
import { animate, scroll } from 'motion';

// when scroll-section enters view, set active class to corresponding media slide
const elements = document.querySelectorAll('.block-scroller-section');
const mediaElements = document.querySelectorAll('.scroll-container--media-wrapper--media-rotate');
if (elements.length > 0) {
	sal({
		root: null,
		selector: '.block-scroller-section',
		animateClassName: 'active',
		enterEventName: 'scroller-enter',
		exitEventName: 'scroller-exit',
		once: false,
	});

	elements.forEach((element) => {
		element.addEventListener('scroller-enter', ({ detail }) => {
			const child = detail.target;
			const parent = child.parentNode;
			const currentIndex = Array.prototype.indexOf.call(parent.children, child);
			mediaElements.forEach((mediaElement) => {
				if (parseInt(mediaElement.dataset.eq) === currentIndex) {
					mediaElement.classList.add('active');
				} else {
					mediaElement.classList.remove('active');
				}
			});
		});
	});
}

document.querySelectorAll('.scroll-row--content').forEach((item) => {
	scroll(animate(item, { opacity: [0, 1, 1, 0] }), {
		target: item,
		offset: ['start end', 'end end', 'start start', 'end start'],
	});
});
